import config from 'config';
import { BRANDS, ENVIRONMENTS } from 'config/environments/shared';

const isProduction = config.app.environment === ENVIRONMENTS.PRODUCTION;

const createLink = (resellerId: string, domain?: string) =>
  `https://${!isProduction ? 'h' : ''}minhaloja.${domain}/redirect/${resellerId}/?origin=${
    config.app.slugname
  }`;

const brands = [
  { brand: 'BOTICARIO', name: 'Boticário', domain: 'boticario.com.br' },
  { brand: 'EUAMOMAKE', name: 'Eu Amo Make', domain: 'quemdisseberenice.com.br' },
  { brand: 'OUI', name: 'O.U.I', domain: 'ouiparis.com' },
  { brand: 'EUDORA', name: 'Eudora', domain: 'eudora.com.br' },
];

const createBrandData = (
  resellerId: string,
  brandInfo: { brand: string; name: string; domain: string }
) => ({
  brand: brandInfo.brand,
  name: brandInfo.name,
  link: createLink(resellerId, brandInfo.domain),
  isFallback: true,
});

export const getCatalogMldLinks = (resellerId: string, isMultiBrand = false) => {
  const data = brands.map((brand) => createBrandData(resellerId, brand));

  if (config.app.slugname === BRANDS.EUD) {
    return { data: [data.find((brand) => brand.brand === BRANDS.EUD.toUpperCase())] };
  }

  if (!isMultiBrand) {
    return { data: data.filter((brand) => brand.brand !== BRANDS.EUD.toUpperCase()) };
  }

  return { data };
};
